import React, { Component, useState,useEffect,useCallback } from 'react';
import { Row, Container, Col, Form, Button, Modal,Collapse, Spinner, Nav, Tab } from "react-bootstrap";
import Multiselect from 'multiselect-react-dropdown';
import { FaAngleDown } from 'react-icons/fa';
import N from '../lib/Network'
import AC from '../lib/AppConsts'
import S from '../lib/Security'
import swal from 'sweetalert'
import Loader from './Loader'
var CryptoJS = require("crypto-js");

const EditTenant = ({ showUserPopupEdit, closeEditModal,oldRecord }) => {
    const [key,setKey]= useState("first");
    const [companyName,setCompanyName]= useState('');
    const [contactNo,setContactNo] =useState('');
    const [tenantRegNo,setTenantRegNo] =useState('');
    const [taxRegNo,setTaxRegNo] =useState('');
    const [expenzingSPOCName,setExpenzingSPOCName] =useState('');
    const [expenzingSPOCId,setExpenzingSPOCId] =useState('');
    const [tenantCityName,setTenantCityName] =useState('');
    const [tenantCityId,setTenantCityId] =useState('');
    const [tenantPOC,setTenantPOC] = useState('');
    const [tenantEmailID,setTenantEmailID] = useState('');
    const [tenantAdminFirstName,setTenantAdminFirstName] = useState('');
    const [tenantAdminMiddleName,setTenantAdminMiddleName] = useState('');
    const [tenantAdminLastName,setTenantAdminnLastName] = useState('');
    const [tenantAdminEmpCode,setTenantAdminEmpCode] = useState('');
    const [adminContactNo,setAdminContactNo] = useState('');
    const [subscriptionList,setSubscriptionList] = useState([ ]);
    const [expenzingSPOCData,setExpenzingSPOCData] = useState('');
    const [procureToPayData,setProcureToPayData] = useState('');
    const [productAssignmentData,setProductAssignmentData] = useState('');
    const [subscriptionListData,setSubscriptionListData] = useState('');
    const [tenantCityData,setTenantCityData] = useState('');
    const [errors,setErrors] = useState({});
    const [productAssignList,setProductAssignList] = useState([ ]);
    const [product,setProduct] = useState([ ]);
    const [mod,setMod] = useState([ ]);
    
    const [loginType,setLoginType]=useState('');
    const [tenantId, setTenantId] = useState('');
    const [createdByIdEditSite,setCreatedByIdEditSite] = useState('');
    const[locationBasedOnZoneData,setLocationBasedOnZoneData] =  useState('');
    const[locationBasedOnZoneDataForRent,setLocationBasedOnZoneDataForRent] =  useState('');
    const [modRent,setModRent] = useState([ ]);
    var [ProductBasedonModule] = useState();
    const [ radioValue, setRadioValue ] = useState('No');
    const [showLoader, setShowLoader] = useState(false);
    const [ldapHost, setLdapHost] = useState('');
    const [ldapSecurity, setLdapSecurity] = useState('');
    const [ldapSearchBase, setLdapSearchBase] = useState('');
    const [ldapDomain, setLdapDomain] = useState('');
    const [ erfxRadioValue, setErfxRadioValue ] = useState('No');
    const [selectedProductIds, setSelectedProductIds] = useState([]);
    const [openP2P, setOpenP2P] = useState(false);
    const [openRent, setOpenRent] = useState(false);

       const [apiList, setApiList] = useState([]);
        const [assignedApis, setAssignedApis] = useState({});
        const [walletBalance, setWalletBalance] = useState(0);
        const [selectedModules, setSelectedModules] = useState({});
    
    useEffect(() => {
        getKeys();
        if(oldRecord?.oldData?.tenantId){
            findByTenantData();
        }
            fetchExpenzingSPOCData();
            fetchProcureToPayData();
            fetchProductAssignmentData();
            fetchSubscriptionListData();
            fetchTenantCityData();
            fetchApiTypeData();
      }, [])
      const showLoaderPopup = () => { setShowLoader(true) }
      const closeLoader = () => { setShowLoader(false) }

      const toggleModule = (moduleId, isChecked) => {
        setSelectedModules((prev) => ({
          ...prev,
          [moduleId]: isChecked,
        }));
    
        // If unchecked, remove all related APIs from assignedApis
        // if (!isChecked) {
        //   setAssignedApis((prev) =>
        //     Object.fromEntries(
        //       Object.entries(prev).filter(([apiId, api]) =>
        //         apiList.some((api) => api.apiId === Number(apiId) && api.moduleId !== moduleId)
        //       )
        //     )
        //   );
        // }
      };
    
      // Toggle API assignment
      const toggleAssignment = (apiId, isChecked) => {
        setAssignedApis((prev) => ({
          ...prev,
          [apiId]: isChecked ? { cost: 0 } : undefined,
        }));
      };
    
      // Update cost
      const updateCost = (apiId, cost) => {
        const formattedCost = cost ? parseFloat(cost) : "0.00"; // Ensure two decimal places
        setAssignedApis((prev) => ({
            ...prev,
            [apiId]: { cost: cost },
        }));
    };


      function getKeys(){
        if(S.getPrivateKey() == '' && S.getPublicKey() == ''){
          N.getRSAApi('/getRsaKeys')
          .then(res => {
              let resObj = JSON.parse(res.data);
              let resJson = JSON.parse(resObj.responseJson);
              if(resJson.privateKey && resJson.publicKey){
                  let newKey = CryptoJS.enc.Utf8.parse('NexStepPrivacy@#');
                  // Decrypt
                  var privateKeyBytes = CryptoJS.AES.decrypt(resJson.privateKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                  S.privateKey = privateKeyBytes.toString(CryptoJS.enc.Utf8);
      
                  var publicKeyBytes = CryptoJS.AES.decrypt(resJson.publicKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                  S.publicKey = publicKeyBytes.toString(CryptoJS.enc.Utf8);
                  
                 
              }
          })
          .catch(err => {
              console.log("Error : "+err);
          });
        }
      }
      var [tenant] = useState()
      var editdata='';
      const findByTenantData = () => {
        tenant = {
            tenantId:oldRecord?.oldData?.tenantId
        };
        N.postApi('getTenantListById',tenant)
        .then(res => {
            var response = S.getDecryptedJSON(res);
            var editeddata=JSON.parse(response.responseJson);
            editdata=editeddata.Payload.userData;
            setTenantCityName(editdata[0].Address);
            setCompanyName(editdata[0].Company_Name);
            setContactNo(editdata[0].Company_Contact_No);
            setTenantRegNo(editdata[0].Company_Reg_No);
            setTaxRegNo(editdata[0].Tax_Reg_No);
            setExpenzingSPOCId(editdata[0].Expenzing_SPOC_id);
            setExpenzingSPOCName(editdata[0].Expenzing_SPOC_Name);
            setTenantCityId(editdata[0].Tenant_Location_Id);
            setSubscriptionList(JSON.parse(editdata[0].subscription));
            setTenantPOC(editdata[0].Tenant_Admin);
            setTenantEmailID(editdata[0].Tenant_Email_ID);
            setAdminContactNo(editdata[0].Tenant_Contact_No);
            setProduct(JSON.parse(editdata[0].product));

            if(editdata[0].Module){

                const parsedModule = JSON.parse(editdata[0].Module);
                if (parsedModule instanceof Array && parsedModule.length > 0) {
                    const firstItem = parsedModule[0];
                    if (firstItem.moduleId) {
                        setMod(parsedModule);
                    }
                } else if (parsedModule instanceof Object && Object.keys(parsedModule).length > 0) {
                    if (parsedModule.moduleId) {
                        setMod(parsedModule);
                    }
                }
           }

           if(editdata[0].ModuleRent){
            const parsedModule = JSON.parse(editdata[0].ModuleRent);
            if (parsedModule instanceof Array && parsedModule.length > 0) {
                const firstItem = parsedModule[0];
                if (firstItem.moduleId) {
                    setModRent(parsedModule);
                }
            } else if (parsedModule instanceof Object && Object.keys(parsedModule).length > 0) {
                if (parsedModule.moduleId) {
                    setModRent(parsedModule);
                }
            }
           }

           if (editdata[0].AssignedApis) {
                const assignedApiData = JSON.parse(editdata[0].AssignedApis);
                const formattedAssignedApis = {};

                assignedApiData.forEach(api => {
                    formattedAssignedApis[api.apiId] = {
                        cost: parseFloat(api.cost).toFixed(2) || "0.00",
                    };
                });

                setAssignedApis(formattedAssignedApis);
            }
            if (editdata[0]?.WalletBalance) {  // Use optional chaining to prevent errors
                setWalletBalance(parseFloat(editdata[0].WalletBalance).toFixed(2));
            } else {
                setWalletBalance("0.00");  // Ensure default value is set properly
            }

            setLoginType(editdata[0].loginDetails);
            setTenantId(editdata[0].tenantId);
            setCreatedByIdEditSite(editdata[0].createdById);
            setTenantAdminEmpCode(editdata[0].tenant_Emp_Code);
            setTenantAdminFirstName(editdata[0].tenant_First_Name);
            setTenantAdminMiddleName(editdata[0].tenant_Middle_Name);
            setTenantAdminnLastName(editdata[0].tenant_Last_Name);
            
            const subs = JSON.parse(editdata[0].subscription);
            const mobilesub = subs.filter((e)=> Number(e.subscription_Id) == Number(11) && e.subscription_Value=="Yes" );
            if(mobilesub.length==1){
                setRadioValue('Yes')
            }
            const erfxSub = subs.filter((e)=> Number(e.subscription_Id) == Number(13) && e.subscription_Value=="Yes" );
            if(erfxSub.length==1){
                setErfxRadioValue('Yes')
            }
            setLdapHost(editdata[0].ldapHost);
            setLdapSecurity(editdata[0].ldapSecurity);
            setLdapSearchBase(editdata[0].ldapSearchBase);
            setLdapDomain(editdata[0].ldapDomain);
        })
        .catch(err => {
            console.log("Error : "+err);
        });
      }
    const validateForm = () => {
        let formIsValid = true;
        let err = {};
        var PhPattern = new RegExp(/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i);
        if(companyName ==="" || companyName.length<=0){
          err["companyName"] = "Company Name  cannot be empty";
          formIsValid= false;
        }if(contactNo ==="" || contactNo.length<=0){
            err["contactNo"] = "Contact NUmber  cannot be empty";
            formIsValid= false;
        }else if(contactNo.length!= 10){
            err["contactNo"] = "Please enter valid Contact No";
            formIsValid= false;
        }else if(!PhPattern.test(contactNo)){
            err["contactNo"] = "Please enter valid Contact No ";
            formIsValid= false;
        }
        if(tenantRegNo ==="" || tenantRegNo.length<=0){
            err["tenantRegNo"] = "PAN No cannot be empty";
            formIsValid= false;
        }
        if(taxRegNo ==="" || taxRegNo.length<=0){
            err["taxRegNo"] = "GSTIN cannot be empty";
            formIsValid= false;
        }
        if(expenzingSPOCName ==="" || expenzingSPOCName ===undefined){
            err["Expenzing_SPOC_Name"] = "Expenzing SPOC Name cannot be empty";
            formIsValid= false;
        }
        if(tenantCityName ==="" || tenantCityName ===undefined){
            err["Tenant_City_Name"] = "Tenant City Name cannot be empty";
            formIsValid= false;
        }
        setErrors(err);
        return formIsValid;
    }
    const validateCompanyName = (event) =>{
        var companyNameValidate = {
            Company_Name: event.target.value.trim(),
            tenant_Id:tenantId
        }
        if(companyNameValidate.Company_Name.length !== 0){
            N.postApi('validateManageTenant', companyNameValidate)
            .then(res => {
                var response = S.getDecryptedJSON(res);
                if(response.responseStatus != AC.STATUS_SUCCESS){
                    var msg =JSON.parse(response.responseJson)
                    if(msg != ""){
                        let er = {};
                        er["companyName"] = msg.Payload.Message;
                        setErrors(er);
                    }
                }   
            })
            .catch(err => {
                console.log("Error : " + err);
            });
        }
    }
    const validateCompanyRegNo = (event) =>{
        var companyRegNoValidate = {
            Company_Reg_No: event.target.value.trim(),
            tenant_Id:tenantId
        }
        if(companyRegNoValidate.Company_Reg_No.length !== 0){
            N.postApi('validateManageTenant', companyRegNoValidate)
            .then(res => {
                var response = S.getDecryptedJSON(res);
                if(response.responseStatus != AC.STATUS_SUCCESS){
                    var msg =JSON.parse(response.responseJson)
                    if(msg != ""){
                        let er = {};
                        er["tenantRegNo"] = msg.Payload.Message;
                        setErrors(er);
                        event.target.value = "";
                    }
                }   
            })
            .catch(err => {
                console.log("Error : " + err);
            });
            setErrors({});
        }
    }
    const validateTaxRegNo = (event) =>{
        var taxRegNoValidate = {
            Tax_Reg_No: event.target.value.trim(),
            tenant_Id:tenantId
        }
        if(taxRegNoValidate.Tax_Reg_No.length !== 0){
            N.postApi('validateManageTenant', taxRegNoValidate)
            .then(res => {
                var response = S.getDecryptedJSON(res);
                if(response.responseStatus != AC.STATUS_SUCCESS){
                    var msg =JSON.parse(response.responseJson)
                    if(msg != ""){
                        let er = {};
                        er["taxRegNo"] = msg.Payload.Message;
                        setErrors(er);
                        event.target.value = "";
                    }
                }   
            })
            .catch(err => {
                console.log("Error : " + err);
            });
            setErrors({});
        }
    }
    const validateTenantAdmin = (event) =>{
        var tenantAdminValidate = {
            Tenant_Admin: event.target.value.trim(),
            tenant_Id:tenantId
        }
        if(tenantAdminValidate.Tenant_Admin.length !== 0){
            N.postApi('validateManageTenant', tenantAdminValidate)
            .then(res => {
                var response = S.getDecryptedJSON(res);
                if(response.responseStatus != AC.STATUS_SUCCESS){
                    var msg =JSON.parse(response.responseJson)
                    if(msg != ""){
                        let er = {};
                        er["tenantPOC"] = msg.Payload.Message;
                        setErrors(er);
                        event.target.value = "";
                    }
                }   
            })
            .catch(err => {
                console.log("Error : " + err);
            });
            setErrors({});
        }
    }
    const validateTenantEmailId = (event) =>{
        var tenantEmailIdValidate = {
            Tenant_Email_ID: event.target.value.trim(),
            tenant_Id:tenantId
        }
        if(tenantEmailIdValidate.Tenant_Email_ID.length !== 0){
            N.postApi('validateManageTenant', tenantEmailIdValidate)
            .then(res => {
                var response = S.getDecryptedJSON(res);
                if(response.responseStatus != AC.STATUS_SUCCESS){
                    var msg =JSON.parse(response.responseJson)
                    if(msg != ""){
                        let er = {};
                        er["tenantEmailID"] = msg.Payload.Message;
                        setErrors(er);
                        event.target.value = "";
                    }
                }   
            })
            .catch(err => {
                console.log("Error : " + err);
            });
            setErrors({});
        }
    }
    const validateAdmin = () => {
        let formIsValid = true;
        let err = {};
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        var PhPattern = new RegExp(/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i);
        var onlyAlphabet = /[a-zA-Z]/;
        var alphabetNumeric = /[a-zA-Z0-9]/;
        if(tenantPOC ==="" || tenantPOC.length<=0){
            err["tenantPOC"] = "Tenant POC cannot be empty";
            formIsValid= false;
        }
        if(tenantAdminFirstName ==="" || tenantAdminFirstName.length<=0){
            err["tenantAdminFirstName"] = "Tenant First Name cannot be empty";
            formIsValid= false;
        }else if(!onlyAlphabet.test(tenantAdminFirstName)){
            err["tenantAdminFirstName"] = "Numeric values and special characters not allowed in Tenant First Name.";
            formIsValid= false;
        }
        if(tenantAdminLastName ==="" || tenantAdminLastName.length<=0){
            err["tenantAdminLastName"] = "Tenant Last Name cannot be empty";
            formIsValid= false;
        }else if(!onlyAlphabet.test(tenantAdminLastName)){
            err["tenantAdminLastName"] = "Numeric values and special characters not allowed in Tenant Last Name.";
            formIsValid= false;
        }
        if(tenantAdminEmpCode ==="" || tenantAdminEmpCode.length<=0){
            err["tenantAdminEmpCode"] = "Tenant Emp Code cannot be empty";
            formIsValid= false;
        }else if(!tenantAdminEmpCode.match(alphabetNumeric)){
            err["tenantAdminEmpCode"] = "Special Characters are not allowed in Tenant Employee Code.";
            formIsValid= false;
        }
        if(tenantEmailID ==="" || tenantEmailID.length<=0){
            err["tenantEmailID"] = "Tenant Email ID cannot be empty";
            formIsValid= false;
        }else if(!pattern.test(tenantEmailID)){
            err["tenantEmailID"] = "Please enter valid Email Address.";
            formIsValid= false;
        }
        if(adminContactNo ==="" || adminContactNo.length<=0){
            err["adminContactNo"] = "Admin Contact No cannot be empty";
            formIsValid= false;
        }else if(adminContactNo.length!= 10){
            err["adminContactNo"] = "Please enter valid Contact No";
            formIsValid= false;
        }else if(!PhPattern.test(adminContactNo)){
            err["adminContactNo"] = "Please enter valid Contact No ";
            formIsValid= false;
        }
        setErrors(err);
        return formIsValid;
    }
   const validateModule = () =>{
        let formIsValid = true;
        let err = {};
        if(selectedProductIds.includes("1") && mod.length<=0){
            err["p2p"] = "Select atleast One Module";
            formIsValid= false;
        }
        if(selectedProductIds.includes("2") && modRent.length<=0){
            err["rent"] = "Select atleast One Module";
            formIsValid= false;
        }
        setErrors(err);
        return formIsValid;
    }
    const moduleNextTab = () =>{
        if(validateModule()){
            if (Object.keys(errors).length === 0) {
                handleToggleBeforeNext();
            handleNextTabClick("fourth");
            }
        }
    }

    const handleToggleBeforeNext = () => {
        if (selectedProductIds.includes("1")) {
            setOpenP2P(true);
        }else if(selectedProductIds.includes("2")){
            setOpenRent(true);
        }
        
    };
    
    const nextTab = () =>{ 
        if(validateForm()){
            if (Object.keys(errors).length === 0) {
            handleNextTabClick("second");
            }
        }
    }
    const handleModuleTab =()=>{
        let formIsValid = true;
        let er = {};
        if (Object.keys(product).length === 0) {
            er["Product"] = "Select atleast One Product";
        }else{
            handleNextTabClick("third");
        }
        setErrors(er);
    }
    const handleNextTabClick = (key) => { setKey(key); };
    const handlePreviousTabClick = (key) => { setKey(key); };
    const closePopup = () => { closeEditModal(); clearState(); handleNextTabClick("first"); }
    const validateloginType = () =>{
        let formIsValid = true;
        let err = {};
        if(loginType.length<=0){
            err["logintype"] = "Select atleast One Module";
            formIsValid= false;
        }
        //LDAP Validation
        if(loginType === 'LDAP'){
            if(ldapHost ==="" || ldapHost.length<=0){
                err["ldapHost"] = "Host cannot be empty";
                formIsValid= false;
            }
            if(ldapSecurity ==="" || ldapSecurity.length<=0){
                err["ldapSecurity"] = "Security Authentication cannot be empty";
                formIsValid= false;
            }
            if(ldapSearchBase ==="" || ldapSearchBase.length<=0){
                err["ldapSearchBase"] = "Search Base cannot be empty";
                formIsValid= false;
            }
            if(ldapDomain ==="" || ldapDomain.length<=0){
                err["ldapDomain"] = "Domain cannot be empty";
                formIsValid= false;
            }
        }
        setErrors(err);
            return formIsValid;
    }
    const moduleNextTabfifth = () =>{
        if(validateloginType()){
            handleNextTabClick("sixth");
        }
    }

    
    const moduleNextTabsixth = () =>{
        if(validateAdmin()){
            handleNextTabClick("seventh");
        }
    }

    const fetchExpenzingSPOCData = () => {
        N.getApi('getExpenzingSpocUser')
        .then(res => {
            var response = S.getDecryptedJSON(res);
            setExpenzingSPOCData(JSON.parse(response.responseJson))
        })
    }
    const fetchProcureToPayData = () => {
        N.getApi('getModuleList')
        .then(res => {
            var response = S.getDecryptedJSON(res);
            setProcureToPayData(JSON.parse(response.responseJson))
        })
          
    }
    const fetchProductAssignmentData = () => {
        N.getApi('getProductList')
        .then(res => {
          var response = S.getDecryptedJSON(res);
          setProductAssignmentData(JSON.parse(response.responseJson))
        })
    }
    const fetchSubscriptionListData = () => {
        N.getApi('getSubscriptionList')
        .then(res => {
          var response = S.getDecryptedJSON(res);
          setSubscriptionListData(JSON.parse(response.responseJson))
        })
    }
    const fetchTenantCityData = () => {
        N.getApi('getLocationMsts')
        .then(res => {
           var response = S.getDecryptedJSON(res);
            setTenantCityData(JSON.parse(response.responseJson))
          })
    }

    const fetchApiTypeData = () => {
        N.getApi('getAPIList')
        .then(res => {
            var response = S.getDecryptedJSON(res);
            try {
                // Ensure response.responseJson is parsed correctly
                let parsedData = JSON.parse(response.responseJson);
                
                // Ensure API_LIST exists and is an array
                
                    setApiList(parsedData.Payload.apiList);
               
            } catch (error) {
                console.error("Error parsing API List:", error);
                setApiList([]); // Prevent .map() crash
            }
        })
        .catch(err => {
            console.error("Error fetching API List:", err);
            setApiList([]); // Prevent .map() crash
        });
    };

    const radioHandler = (ev)=>{
        const { name, value,id } = ev.target;
        let er = {};
        /**
         * show hide mobile user count field according to mobile application field
         */
        setRadioValue(ev.target.value);
        /*
        *in subscription module fetching  mobile application ="Yes" and we are change it to "No" then 
        * in subscriptionList update two values one was mobile application and second was Mobile User Count to blank.
        */
        if(name ==="Mobile Application" && value =="No" || value=="0"){
            let index_12 = subscriptionList.findIndex(item =>item.subscription_Id==="12" && item.subscription_Id);
            let index_11 = subscriptionList.findIndex(item =>item.subscription_Id===id && item.subscription_Id);
             er[name] ="";
            const oldRecor = [...subscriptionList];
            oldRecor[index_12] = { "subscription_Id": "12",
                                    "subscription_Name": "Mobile User Count",
                                    "subscription_Value": ""
                                }
            oldRecor[index_11] = { "subscription_Id": id,
                                "subscription_Name": name,
                                "subscription_Value": value
                            }
            setSubscriptionList(oldRecor)
        }else{
             /*
            *in subscription module fetching  mobile application ="No" and we are change it to "Yes" in subscriptionList
            */
            let itemindex = subscriptionList.findIndex(item =>item.subscription_Id===id && item.subscription_Id);
            er[name] ="";
            const oldRecor = [...subscriptionList];
            oldRecor[itemindex] = { "subscription_Id": id,
                                    "subscription_Name": name,
                                    "subscription_Value": value
                                }
            setSubscriptionList(oldRecor);
        }
        setErrors(er);
    };

    const subscriptionHandleChange = (evt) =>{
        const { name, value,id } = evt.target;
        let itemindex = subscriptionList.findIndex(item =>item.subscription_Id===id && item.subscription_Id);
        errors[evt.target.name] ="";
        const oldRecor = [...subscriptionList];
        oldRecor[itemindex] = { "subscription_Id": id,
                                "subscription_Name": name,
                                "subscription_Value": value
                              }
        setSubscriptionList(oldRecor)
    }
    const validateSubscriptionForm = () => {
        let formIsValid = true;
        let er = {};

        let totalUsers = null;
        let coreUsers = null;
        let nonCoreUsers = null;

        subscriptionList.forEach((item) =>{

            if(selectedProductIds.includes("1")){

            if(item.subscription_Name === "Number of Child Companies allowed"){
                if(item.subscription_Value === ""){
                    er["Number of Child Companies allowed"] = "This field cannot be empty";
                    formIsValid= false;
                }
            }
            if(item.subscription_Name === "Total Number of Users allowed"){
                if(item.subscription_Value === ""){
                    er["Total Number of Users allowed"] = "This field cannot be empty";
                    formIsValid= false;
                }
                totalUsers = parseInt(item.subscription_Value);
            }
            if(item.subscription_Name === "Number of Core Users allowed"){
                if(item.subscription_Value === ""){
                    er["Number of Core Users allowed"] = "This field cannot be empty";
                    formIsValid= false;
                }
                coreUsers = parseInt(item.subscription_Value);
            }
            if(item.subscription_Name === "Number of Non Core Users allowed"){
                if(item.subscription_Value === ""){
                    er["Number of Non Core Users allowed"] = "This field cannot be empty";
                    formIsValid= false;
                }
                nonCoreUsers = parseInt(item.subscription_Value);
            }
            if(item.subscription_Name === "Number of PR Vouchers allowed"){
                if(item.subscription_Value === ""){
                    er["Number of PR Vouchers allowed"] = "This field cannot be empty";
                    formIsValid= false;
                }
            }
            if(item.subscription_Name === "Number of PO Vouchers allowed"){
                if(item.subscription_Value === ""){
                    er["Number of PO Vouchers allowed"] = "This field cannot be empty";
                    formIsValid= false;
                }
            }
            if(item.subscription_Name === "Number of Invoices allowed"){
                if(item.subscription_Value === ""){
                    er["Number of Invoices allowed"] = "This field cannot be empty";
                    formIsValid= false;
                }
            }if(item.subscription_Name === "Activation Date"){
                if(item.subscription_Value === ""){
                    er["Activation Date"] = "This field cannot be empty";
                    formIsValid= false;
                }
            }
            if(item.subscription_Name === "Expiry Date"){
                if(item.subscription_Value === ""){
                    er["Expiry Date"] = "This field cannot be empty";
                    formIsValid= false;
                }
            }
            if(item.subscription_Name === "Periodicity for voucher count"){
                if(item.subscription_Value === ""){
                    er["Periodicity for voucher count"] = "This field cannot be empty";
                    formIsValid= false;
                }
            }
            if(item.subscription_Name === "Mobile Application"){
                if((item.subscription_Value === "") || (item.subscription_Value === "0")){
                    er["Mobile Application"] = "Please select an option";
                    formIsValid= false;
                }
            }
            if(item.subscription_Name === "Mobile User Count" && radioValue === "Yes"){
                if(item.subscription_Value === ""){
                    er["Mobile User Count"] = "This field cannot be empty";
                    formIsValid= false;
                }
            } 
            //Erfx Integration Validation
            if(item.subscription_Name === "P2P ERFX Integration"){
                if((item.subscription_Value === "") || (item.subscription_Value === "0")){
                    er["P2P ERFX Integration"] = "Please select an option";
                    formIsValid= false;
                }
            }
            if(erfxRadioValue === "Yes"){
                if(item.subscription_Name === "ERFX API Url" && item.subscription_Value === ""){
                    er["ERFX API Url"] = "This field cannot be empty";
                    formIsValid= false;
                }
                if(item.subscription_Name === "ERFX Cron Expression" && item.subscription_Value === ""){
                    er["ERFX Cron Expression"] = "This field cannot be empty";
                    formIsValid= false;
                }
                if(item.subscription_Name === "ERFX API User" && item.subscription_Value === ""){
                    er["ERFX API User"] = "This field cannot be empty";
                    formIsValid= false;
                }
                if(item.subscription_Name === "ERFX API Password" && item.subscription_Value === ""){
                    er["ERFX API Password"] = "This field cannot be empty";
                    formIsValid= false;
                }
            }

        }
        if(selectedProductIds.includes("2")){
            if(item.subscription_Name === "Total Number of Users for Rent"){
                if(item.subscription_Value === ""){
                    er["Total Number of Users for Rent"] = "This field cannot be empty";
                    formIsValid= false;
                }
            }
            if(item.subscription_Name === "Total Number of Child Companies for Rent"){
                if(item.subscription_Value === ""){
                    er["Total Number of Child Companies for Rent"] = "This field cannot be empty";
                    formIsValid= false;
                }
            }
            if(item.subscription_Name === "Total Number of Branches"){
                if(item.subscription_Value === ""){
                    er["Total Number of Branches"] = "This field cannot be empty";
                    formIsValid= false;
                }
            }
        }
    }
    
    )

    if (
        totalUsers !== null &&
        coreUsers !== null &&
        nonCoreUsers !== null &&
        !isNaN(totalUsers) &&
        !isNaN(coreUsers) &&
        !isNaN(nonCoreUsers)
    ) {
        if (coreUsers > totalUsers) {
            er["Number of Core Users allowed"] = "Core users cannot exceed total users";
            formIsValid = false;
        }
        if ( nonCoreUsers > totalUsers) {
            er["Number of Non Core Users allowed"] = "Non-Core users cannot exceed total users";
            formIsValid = false;
        }
    }
        setErrors(er);
        return formIsValid;
    }
    const saveSubscription =()=>{
        if(validateSubscriptionForm()){
            if (Object.keys(errors).length === 0) {
                setOpenP2P(false);
                setOpenRent(false);
            handleNextTabClick("fifth");
            }
        }
    }

    const fetchProductBasedonModule = () =>{
        ProductBasedonModule = { productList :product};
        N.postApi('getModuleListByProduct',ProductBasedonModule)
        .then(res => {
            var response = S.getDecryptedJSON(res);
            //  setLocationBasedOnZoneData(JSON.parse(response.responseJson))
            const moduleList = JSON.parse(response.responseJson).Payload.moduleList;
             const locationData = { Payload: { moduleList: [] } };
            const rentData = { Payload: { moduleList: [] } };

             moduleList.forEach(module => {
              if (module.productId === "1") {
               locationData.Payload.moduleList.push(module);
              } else if (module.productId === "2") {
             rentData.Payload.moduleList.push(module);
            }
    });

            setLocationBasedOnZoneData(locationData);
            setLocationBasedOnZoneDataForRent(rentData);

                    const newSelectedProductIds = [];
                if (locationData.Payload.moduleList.length > 0) {
                newSelectedProductIds.push("1");
                }
                if (rentData.Payload.moduleList.length > 0) {
                newSelectedProductIds.push("2");
                }
                setSelectedProductIds(newSelectedProductIds);
           
        })
        .catch(err => {
             console.log("Error : "+err);
        });
    }
    const handleChange = (event) => {
        if (event.target.name === 'companyName') {
            errors["companyName"] ="";
            setCompanyName( event.target.value );
            setTenantCityName("Mumbai");
            setTenantCityId(1);
        }
        if (event.target.name === 'contactNo') {
            errors["contactNo"] ="";
            setContactNo( event.target.value );
        }
        if (event.target.name === 'tenantRegNo') {
            errors["tenantRegNo"] ="";
            setTenantRegNo( event.target.value );
        }
        if (event.target.name === 'taxRegNo') {
            errors["taxRegNo"] ="";
            setTaxRegNo( event.target.value );
        }
        if (event.target.name === 'Tenant_City_Name') {
            if(event.target.value != 0){
                errors["Tenant_City_Name"] ="";
                const spoc = tenantCityData?.Payload?.locationMstList?.filter((e) => e.locationId === event.target.value && e);
                setTenantCityName(spoc[0].locationName);
                setTenantCityId(spoc[0].locationId);
            }else{
                errors["Tenant_City_Name"] ="";
                setTenantCityName();
                setTenantCityId();
            }
        }
        if (event.target.name === 'tenantPOC') {
            errors["tenantPOC"] ="";
            setTenantPOC( event.target.value );
        }
        if (event.target.name === 'tenantEmailID') {
            errors["tenantEmailID"] ="";
            setTenantEmailID( event.target.value );
        }
        if (event.target.name === 'tenantAdminFirstName') { 
            setTenantAdminFirstName( event.target.value );
        }
        if (event.target.name === 'tenantAdminMiddleName') { 
            setTenantAdminMiddleName( event.target.value );
        }
        if (event.target.name === 'tenantAdminLastName') { 
            setTenantAdminnLastName( event.target.value );
        }
        if (event.target.name === 'tenantAdminEmpCode') { 
            setTenantAdminEmpCode( event.target.value );
        }
        if (event.target.name === 'adminContactNo') {
            errors["adminContactNo"] ="";
            setAdminContactNo( event.target.value );
        }
        if (event.target.name === 'Expenzing_SPOC_Name') {
            if(event.target.value != 0){
                errors["Expenzing_SPOC_Name"] ="";
                const spoc = expenzingSPOCData?.Payload?.spocList?.filter((e) => e.SpocId === event.target.value && e);
                setExpenzingSPOCName(spoc[0].SpocName);
                setExpenzingSPOCId(spoc[0].SpocId);
            }else{
                errors["Expenzing_SPOC_Name"] ="";
                setExpenzingSPOCName();
                setExpenzingSPOCId();
            }
        }
    }
    const onselectProduct = (data) =>{setProduct(data);} 
    const onRemoveProduct = (data) => {
        setProduct(data);
        const remainingProductIds = data.map(item => item.id);
        setSelectedProductIds(remainingProductIds);

        // Clear mod and modRent based on the remaining products
        if (!remainingProductIds.includes("1")) {
            setMod([]);
        }
        if (!remainingProductIds.includes("2")) {
            setModRent([]);
        }
    };
    const onSelect = (selectedList, selectedItem) => {
        setMod(selectedList);
      };
    
      const onRemove = (selectedList, removedItem) => {
        setMod(selectedList);
      };
      const onSelectRent = (selectedList, selectedItem) => {
        setModRent(selectedList);
      };
    
      const onRemoveRent = (selectedList, removedItem) => {
        setModRent(selectedList);
      };
    
     

    const productjson =()=>{
        let item = []
        const prod = productAssignList?.filter((e) => e.checked === true && e).map((re)=>(
            {"product_Name":re.name,"product_Id":re.id}
         )) 
        setProduct([...product,...prod]);
    }
    const saveTabDetails = (event) => {
        if(validateAdmin()){

            const hasMissingCost = Object.entries(assignedApis).some(([_, value]) => 
                value !== undefined && (value.cost === "" || value.cost === null || isNaN(value.cost) || value.cost == 0 && value.cost == 0.0  )
            );
    
            if (hasMissingCost) {
                alert("Please enter a valid cost for all assigned APIs.");
                return;
            }

            const isAnyApiAssigned = Object.values(assignedApis).some(value => value !== undefined);

            const parsedWalletBalance = parseFloat(walletBalance || 0).toFixed(2);
            setWalletBalance(parsedWalletBalance); 

            if (isAnyApiAssigned && (parsedWalletBalance === null || parsedWalletBalance === undefined || parsedWalletBalance === "" || isNaN(parsedWalletBalance) || parseFloat(parsedWalletBalance) === 0)) {
                alert("Wallet balance cannot be empty or zero if an API is assigned.");
                return;
            }

            if (Object.keys(errors).length === 0) {
            showLoaderPopup();

            const assignedApiList = Object.entries(assignedApis)
            .filter(([_, value]) => value !== undefined)
            .map(([apiId, value]) => ({
                apiId: Number(apiId),
                rate: parseFloat(value.cost).toFixed(2),
            }));

            var TabObj = {
                Address:tenantCityName,
                Company_Name: companyName,
                Company_Contact_No: contactNo,
                Company_Reg_No: tenantRegNo,
                Tax_Reg_No: taxRegNo,
                Expenzing_SPOC_id:expenzingSPOCId,
                Expenzing_SPOC_Name: expenzingSPOCName,
                Tenant_Location_Id: tenantCityId,
                Tenant_Location_Name: tenantCityName,
                subscription :subscriptionList,
                Tenant_Admin : tenantPOC,
                Tenant_Email_ID : tenantEmailID,
                Tenant_First_Name : tenantAdminFirstName,
                Tenant_Middle_Name : tenantAdminMiddleName,
                Tenant_Last_Name : tenantAdminLastName,
                Tenant_Emp_Code : tenantAdminEmpCode,
                Tenant_Contact_No : adminContactNo,
                product : product,
                Module : mod,               
                loginDetails : loginType,
                action : AC.ACTION_UPDATE,
                createdById : createdByIdEditSite,
                modifiedById : localStorage.getItem("userId"),
                tenant_Id : tenantId,
                ldapHost : ldapHost,
                ldapSecurity : ldapSecurity,
                ldapSearchBase : ldapSearchBase,
                ldapDomain : ldapDomain,
                ModuleRent : modRent,
                assignedApis: assignedApiList,
                walletBalance: walletBalance  
            }
            return N.postApi('updateTenant',TabObj)
            .then(res => {
                var response = S.getDecryptedJSON(res);
                if(response.responseStatus === AC.STATUS_SUCCESS){
                    closeLoader();
                    swal("Success!", "Record Saved Suceesfully", "success", { buttons: false,timer: 2000,});
                    closePopup();
                    setTimeout(() => {
                        window.location.reload(true); 
                    }, 2000);
                }else{
                    closeLoader();
                    swal("Error!", "Record Not Saved", "warning", { buttons: false,timer: 2000,});
                    document.getElementById("updateTenant").disabled = false;
                }
            })
            .catch(err => {
                console.log("Error : " + err);
            });
        }
        }
    }
    const handleLdapHostChange = (e) => {
        errors[e.target.name] ="";
        setLdapHost(e.target.value);
    };
    const handleLdapSecurityChange = (e) => {
        errors[e.target.name] ="";
        setLdapSecurity(e.target.value);
    };
    const handleLdapSearchBaseChange = (e) => {
        errors[e.target.name] ="";
        setLdapSearchBase(e.target.value);
    };
    const handleLdapDomainChange = (e) => {
        errors[e.target.name] ="";
        setLdapDomain(e.target.value);
    };
    const erfxRadioHandler = (ev)=>{
        const { name, value,id } = ev.target;
        let er = {};
        setErfxRadioValue(ev.target.value);
        if(name ==="P2P ERFX Integration" && value =="No" || value=="0"){
            let index_14 = subscriptionList.findIndex(item =>item.subscription_Id==="14" && item.subscription_Id);
            let index_15 = subscriptionList.findIndex(item =>item.subscription_Id==="15" && item.subscription_Id);
            let index_16 = subscriptionList.findIndex(item =>item.subscription_Id==="16" && item.subscription_Id);
            let index_17 = subscriptionList.findIndex(item =>item.subscription_Id==="17" && item.subscription_Id);
            let index_13 = subscriptionList.findIndex(item =>item.subscription_Id===id && item.subscription_Id);
            
            er[name] ="";
            const oldRecor = [...subscriptionList];
            oldRecor[index_14] = { "subscription_Id": "14",
                                    "subscription_Name": "ERFX API Url",
                                    "subscription_Value": ""
            }
            oldRecor[index_15] = { "subscription_Id": "15",
                                    "subscription_Name": "ERFX Cron Expression",
                                    "subscription_Value": ""
            }
            oldRecor[index_16] = { "subscription_Id": "16",
                                    "subscription_Name": "ERFX API User",
                                    "subscription_Value": ""
            }
            oldRecor[index_17] = { "subscription_Id": "17",
                                    "subscription_Name": "ERFX API Password",
                                    "subscription_Value": ""
            }
            oldRecor[index_13] = { "subscription_Id": id,
                                "subscription_Name": name,
                                "subscription_Value": value
            }
            setSubscriptionList(oldRecor)
        }else{
            let itemindex = subscriptionList.findIndex(item =>item.subscription_Id===id && item.subscription_Id);
            er[name] ="";
            const oldRecor = [...subscriptionList];
            oldRecor[itemindex] = { "subscription_Id": id,
                                    "subscription_Name": name,
                                    "subscription_Value": value
                                }
            setSubscriptionList(oldRecor);
        }
        setErrors(er);
    };
    const clearState = () =>{
        setTenantCityName('');setCompanyName('');setContactNo('');setTenantRegNo('');setTaxRegNo('');setExpenzingSPOCId('');setExpenzingSPOCName('');setTenantCityId('');setErrors({});
        setTenantCityName('');setSubscriptionList([]);setTenantPOC('');setTenantEmailID('');setAdminContactNo('');setProduct([]);setMod([]);setModRent([]);setLoginType('');fetchSubscriptionListData();}
        return (
        <Modal id="addUser" show={showUserPopupEdit}  animation={true}  size="xl">
            <Modal.Header closeButton onClick={() => closePopup()}>
                <Modal.Title><h5 className="headerTitle">Update Tenant</h5></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container fluid>
                    <Tab.Container id="left-tabs-example" onChange={handleNextTabClick} activeKey={key} >
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <div className="multi-step">
                                    <Nav variant="pills" className="nav-justified">
                                        <Nav.Item>
                                            <Nav.Link className="item-wrap" eventKey="first"><p className="item-title disabled">Company Details</p></Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link className="item-wrap" eventKey="second"><p className="item-title disabled">Product Assignment</p></Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link className="item-wrap" eventKey="third"><p className="item-title disabled">Module Assignment</p></Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link className="item-wrap" eventKey="fourth"><p className="item-title disabled">Subscription Assignment</p></Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link className="item-wrap" eventKey="fifth"><p className="item-title disabled">Login Details</p></Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link className="item-wrap" eventKey="sixth"><p className="item-title disabled">Tenant Admin</p></Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                             <Nav.Link className="item-wrap" eventKey="seventh"><p className="item-title disabled">Expenzing API Assignment</p></Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </div>
                            </Col>
                            <Col xs={12} md={12} lg={12} className="mt-4">
                                <Tab.Content>
                                    <Tab.Pane eventKey="first">
                                        <Row>
                                            <Col xs={6} md={3} lg={3}>
                                                
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Tenant Name</Form.Label>
                                                    <Form.Control id="" name="companyName" defaultValue={companyName} type="text" className="form-control" placeholder="Enter Tenant Name" onChange={handleChange} onKeyUp={validateCompanyName} onBlur={validateCompanyName}/>
                                                    <div className="invalid-feedback">{errors["companyName"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Contact No.</Form.Label>
                                                    <Form.Control id="" name="contactNo" defaultValue={contactNo} type="number" className="form-control" placeholder="Enter Contact No." onChange={handleChange}/>
                                                    <div className="invalid-feedback">{errors["contactNo"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>PAN No.</Form.Label>
                                                    <Form.Control id="name" name="tenantRegNo" defaultValue={tenantRegNo} type="text" className="form-control" placeholder="Enter PAN No." onChange={handleChange} onKeyUp={validateCompanyRegNo}/>
                                                    <div className="invalid-feedback">{errors["tenantRegNo"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>GSTIN No.</Form.Label>
                                                    <Form.Control id="name" name="taxRegNo" defaultValue={taxRegNo} type="text" className="form-control" placeholder="Enter GSTIN No." onChange={handleChange} onKeyUp={validateTaxRegNo}/>
                                                    <div className="invalid-feedback">{errors["taxRegNo"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Expenzing SPOC</Form.Label>
                                                    <Form.Select name="Expenzing_SPOC_Name" value={expenzingSPOCId} id="Expenzing_SPOC_id" className="form-control" onChange={handleChange}>
                                                        <option value="0">- Select SPOC -</option>
                                                        {expenzingSPOCData?.Payload?.spocList?.map((result) => {
                                                        return (
                                                        <option  value={result.SpocId}>{result.SpocName}</option>
                                                        )})}
                                                    </Form.Select>
                                                    <div className="invalid-feedback">{errors["Expenzing_SPOC_Name"]}</div>
                                                </Form.Group>
                                            </Col>
                                            {/* <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Tenant City</Form.Label>
                                                    <Form.Select name="Tenant_City_Name" value={tenantCityId} className="form-control" id="Tenant_City_Id" onChange={handleChange}>
                                                        <option value="0">- Select Tenant City -</option>
                                                        {tenantCityData?.Payload?.locationMstList?.map((result) => {
                                                        return (
                                                        <option value={result.locationId}>{result.locationName}</option>
                                                        )})} 
                                                    </Form.Select>
                                                    <div className="invalid-feedback">{errors["Tenant_City_Name"]}</div>
                                                </Form.Group>
                                            </Col> */}
                                            <Col xs={12} md={12} lg={12} className="text-right mt-2">
                                                <Button type="button" className="btn btn-sm btn-primary dt shadow-sm" onClick={()=>{ nextTab();}}>Next</Button>
                                            </Col>
                                        </Row>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="second">
                                        <Row>
                                            <Col xs={3} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Product Assignment</Form.Label>
                                                    <Multiselect
                                                        name='Product'
                                                        options={productAssignmentData?.Payload?.productList}
                                                        displayValue="productName"
                                                        selectedValues={product}
                                                        closeOnSelect={true}
                                                        onSelect={onselectProduct}
                                                        onRemove={onRemoveProduct}
                                                       
                                                    />
                                                     <div className="invalid-feedback">{errors["Product"]}</div>
                                                 </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={12} md={12} lg={12} className="text-right mt-2">
                                                <Button type="button" className="btn btn-sm btn-primary dt float-left shadow-sm" onClick={()=>handlePreviousTabClick ("first")}>Previous</Button>
                                                <Button type="button" className="btn btn-sm btn-primary dt shadow-sm" onClick={()=>{fetchProductBasedonModule();handleModuleTab(); }}>Next</Button>
                                            </Col>
                                        </Row>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="third">
                                        <Row>
                                        {selectedProductIds.includes("1") && (
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Procure To Pay</Form.Label>
                                                    <Multiselect
                                                        name='p2p'
                                                        options={locationBasedOnZoneData?.Payload?.moduleList}
                                                        displayValue="moduleName"
                                                        onSelect={onSelect}
                                                        onRemove={onRemove}
                                                        selectedValues={mod}
                                                    />
                                                    <div className="invalid-feedback">{errors["p2p"]}</div>
                                                </Form.Group>
                                            </Col>
                                            )}
                                        {selectedProductIds.includes("2") && (
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Rent Enterprise</Form.Label>
                                                    <Multiselect
                                                        name='rent'
                                                        options={locationBasedOnZoneDataForRent?.Payload?.moduleList}
                                                        displayValue="moduleName"
                                                        onSelect={onSelectRent}
                                                        onRemove={onRemoveRent}
                                                        selectedValues={modRent}
                                                    />
                                                    <div className="invalid-feedback">{errors["rent"]}</div>
                                                </Form.Group>
                                            </Col>
                                            )}
                                            <Col xs={12} md={12} lg={12} className="text-right mt-2">
                                                <Button type="button" className="btn btn-sm btn-primary dt float-left shadow-sm" onClick={()=>handleNextTabClick ("second")}>Previous</Button>
                                                <Button type="button" className="btn btn-sm btn-primary dt shadow-sm" onClick={()=>{moduleNextTab();}}>Next</Button>
                                            </Col>
                                        </Row>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="fourth">
                                     

                                    <Row>
                                    {/* Toggle Button for P2P Section */}
                                    {selectedProductIds.includes("1") && (
                                    <Button style ={{marginTop:'15px',backgroundColor:'#ededed',border:'1px solid #ededed',color:'#4285f4',textAlign:'left'}}
                                        onClick={() => setOpenP2P(!openP2P)}
                                        aria-controls="collapse-p2p"
                                        aria-expanded={openP2P}
                                    >
                                         P2P Section <FaAngleDown />
                                    </Button>
                                    )}
                                    <Collapse in={openP2P}>
                                        <Row id="collapse-p2p" style={{marginTop:'15px'}}>

                                            {subscriptionListData?.Payload?.subscriptionList?.map((result, index) => {
                                                return (
                                                    <Col xs={6} md={3} lg={3}>
                                                        {
                                                            ((result.subscription_Name.includes("Number of Child Companies allowed")) || (result.subscription_Name.includes("Total Number of Users allowed"))
                                                            || (result.subscription_Name.includes("Number of Core Users allowed")) || (result.subscription_Name.includes("Number of Non Core Users allowed"))) ?
                                                            <>
                                                                <Form.Label>{result.subscription_Name}</Form.Label>
                                                                <Form.Control id={result.subscription_Id} type={result.subscription_Name.includes("Date") ?  "date"  :  "number" } name={result.subscription_Name} className="form-control" defaultValue={subscriptionList.filter((teo) => teo.subscription_Id === (result.subscription_Id)).map((item, i) => {return item.subscription_Value})} onBlur={subscriptionHandleChange} />
                                                                <div className="invalid-feedback">{errors[result.subscription_Name]}</div>
                                                            </> :
                                                            <></>
                                                        }
                                                    {
                                                        (result.subscription_Name.includes("Application")) ?
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>{result.subscription_Name}</Form.Label>
                                                            <Form.Select id={result.subscription_Id} name={result.subscription_Name} value={subscriptionList.filter((teo) => teo.subscription_Id.includes(result.subscription_Id)).map((item) => {return item.subscription_Value})} className="form-control" onChange={radioHandler}>
                                                                <option value="0" >- Select Mobile Application -</option>
                                                                <option value="Yes">Yes</option>
                                                                <option value="No">No</option>
                                                            </Form.Select>
                                                            <div className="invalid-feedback">{errors[result.subscription_Name]}</div>
                                                        </Form.Group> 
                                                        :
                                                        <Form.Group className="mb-3">
                                                            {
                                                                ((result.subscription_Name.includes("Mobile User Count")) && (radioValue === "Yes")) ?
                                                                <div>
                                                                    <Form.Label>{result.subscription_Name}</Form.Label>
                                                                    <Form.Control id={result.subscription_Id} type={"number"} name={result.subscription_Name} className="form-control" defaultValue={subscriptionList.filter((teo) => teo.subscription_Id.includes(result.subscription_Id)).map((item) => {return item.subscription_Value})} onBlur={subscriptionHandleChange} />
                                                                    <div className="invalid-feedback">{errors[result.subscription_Name]}</div>
                                                                </div> :
                                                                <div>
                                                                    {
                                                                        (!result.subscription_Name.includes("Mobile User Count")) && (!result.subscription_Name.includes("ERFX")) && (!result.subscription_Name.includes("Number of Child Companies allowed") && (!result.subscription_Name.includes("Total Number of Child Companies for Rent"))
                                                                        && (!result.subscription_Name.includes("Total Number of Users allowed") && (!result.subscription_Name.includes("Number of Core Users allowed")) && (!result.subscription_Name.includes("Number of Non Core Users allowed")))
                                                                        && (!result.subscription_Name.includes("Total Number of Users for Rent")) && (!result.subscription_Name.includes("Total Number of Branches")))?
                                                                        <>
                                                                            <Form.Label>{result.subscription_Name}</Form.Label>
                                                                            <Form.Control id={result.subscription_Id} type={result.subscription_Name.includes("Date") ?  "date"  :  "number" } name={result.subscription_Name} className="form-control" defaultValue={subscriptionList.filter((teo) => teo.subscription_Id === (result.subscription_Id)).map((item, i) => {return item.subscription_Value})} onBlur={subscriptionHandleChange} />
                                                                            <div className="invalid-feedback">{errors[result.subscription_Name]}</div>
                                                                        </> :
                                                                        <></>
                                                                    }
                                                                </div>
                                                            }    
                                                        </Form.Group> 
                                                    }
                                                    {/* P2P ERFX Integration Fields */}
                                                    {
                                                        (result.subscription_Name.includes("P2P ERFX Integration")) ?
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>{result.subscription_Name}</Form.Label>
                                                            <Form.Select id={result.subscription_Id} name={result.subscription_Name} value={subscriptionList.filter((teo) => teo.subscription_Id.includes(result.subscription_Id)).map((item) => {return item.subscription_Value})} className="form-control" onChange={erfxRadioHandler}>
                                                                <option value="0" >- Choose an option -</option>
                                                                <option value="Yes">Yes</option>
                                                                <option value="No">No</option>
                                                            </Form.Select>
                                                            <div className="invalid-feedback">{errors[result.subscription_Name]}</div>
                                                        </Form.Group> 
                                                        :
                                                        <Form.Group className="mb-3">
                                                            {
                                                                ((result.subscription_Name.includes("ERFX")) && (erfxRadioValue === "Yes")) ?
                                                                <>
                                                                    <Form.Label>{result.subscription_Name}</Form.Label>
                                                                    <Form.Control id={result.subscription_Id} type={"text"} name={result.subscription_Name} className="form-control" defaultValue={subscriptionList.filter((teo) => teo.subscription_Id.includes(result.subscription_Id)).map((item) => {return item.subscription_Value})} onBlur={subscriptionHandleChange} />
                                                                    <div className="invalid-feedback">{errors[result.subscription_Name]}</div>
                                                                </> : <></>
                                                            }
                                                        </Form.Group>
                                                    }
                                                    
                                                </Col>
                                                )})}
                                            </Row>
                                            </Collapse>
                                            {selectedProductIds.includes("2") && (
                                            <Button style ={{marginTop:'15px',backgroundColor:'#ededed',border:'1px solid #ededed',color:'#4285f4',textAlign:'left'}}
                                               onClick={() => setOpenRent(!openRent)}
                                                       aria-controls="collapse-rent"
                                                    aria-expanded={openRent}
                                                    >
                                                     Rent Section <FaAngleDown />
                                                       
                                                   </Button>
                                            )}
                                            <Collapse in={openRent}>
                                            <Row id="collapse-rent" style={{marginTop:'15px'}}>
                                            {subscriptionListData?.Payload?.subscriptionList?.map((result, index) => {
                                                return (
                                                    <>
                                                        {
                                                            ((result.subscription_Name.includes("Total Number of Child Companies for Rent"))
                                                              ) ?
                                                            <Col xs={6} md={3} lg={3}>
                                                                <Form.Label>Number of Child Companies allowed</Form.Label>
                                                                <Form.Control id={result.subscription_Id} type={result.subscription_Name.includes("Date") ?  "date"  :  "number" } name={result.subscription_Name} className="form-control" defaultValue={subscriptionList.filter((teo) => teo.subscription_Id === (result.subscription_Id)).map((item, i) => {return item.subscription_Value})} onBlur={subscriptionHandleChange} />
                                                                <div className="invalid-feedback">{errors[result.subscription_Name]}</div>
                                                            </Col> :
                                                            <></>
                                                        }
                                                         {
                                                            ( (result.subscription_Name.includes("Total Number of Users for Rent")) ) ?
                                                            <Col xs={6} md={3} lg={3}>
                                                                <Form.Label>Total Number of Users allowed</Form.Label>
                                                                <Form.Control id={result.subscription_Id} type={result.subscription_Name.includes("Date") ?  "date"  :  "number" } name={result.subscription_Name} className="form-control" defaultValue={subscriptionList.filter((teo) => teo.subscription_Id === (result.subscription_Id)).map((item, i) => {return item.subscription_Value})} onBlur={subscriptionHandleChange} />
                                                                <div className="invalid-feedback">{errors[result.subscription_Name]}</div>
                                                                </Col> :
                                                            <></>
                                                        }
                                                         {
                                                            ((result.subscription_Name.includes("Total Number of Branches"))) ?
                                                            <Col xs={6} md={3} lg={3}>
                                                                <Form.Label>{result.subscription_Name}</Form.Label>
                                                                <Form.Control id={result.subscription_Id} type={result.subscription_Name.includes("Date") ?  "date"  :  "number" } name={result.subscription_Name} className="form-control" defaultValue={subscriptionList.filter((teo) => teo.subscription_Id === (result.subscription_Id)).map((item, i) => {return item.subscription_Value})} onBlur={subscriptionHandleChange} />
                                                                <div className="invalid-feedback">{errors[result.subscription_Name]}</div>
                                                                </Col> :
                                                            <></>
                                                        }
                                                    </>
                                                     
                                                )})}
                                              </Row>
                                               </Collapse>
                                            <Col xs={12} md={12} lg={12} className="text-right mt-20" >
                                                <Button type="button" className="btn btn-sm btn-primary dt float-left shadow-sm" onClick={()=>handleNextTabClick ("third")}>Previous</Button>
                                                <Button type="button" className="btn btn-sm btn-primary dt shadow-sm" onClick={saveSubscription}>Next</Button>
                                            </Col>
                                            </Row>
                                        
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="fifth">
                                        <Row>
                                            <Col xs={12} md={12} lg={12}>
                                                <div key='' >
                                                    <Form.Check inline label="ADFS" value="ADFS" name="logintype" checked={loginType == 'ADFS'} disabled={true} type='radio'  />
                                                    <Form.Check inline label="SSO" value="SSO" name="logintype" checked={loginType == 'SSO'} disabled={true} type='radio'/>
                                                    <Form.Check inline label="LDAP" value="LDAP" name="logintype" checked={loginType == 'LDAP'} disabled={true} type='radio'/>
                                                    <div className="invalid-feedback">{errors["logintype"]}</div>
                                                </div>
                                                {/* LDAP Fields */}
                                                {loginType === "LDAP" && (
                                                    <Row>
                                                    <Col xs={6} md={3} lg={3}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Host</Form.Label>
                                                            <Form.Control type="text" name="ldapHost" className="form-control" placeholder="Enter Host" defaultValue={ldapHost} onChange={handleLdapHostChange} />
                                                            <div className="invalid-feedback">{errors["ldapHost"]}</div>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs={6} md={3} lg={3}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Security Authentication</Form.Label>
                                                            <Form.Control type="text" name="ldapSecurity" className="form-control" placeholder="Enter Security Authentication" defaultValue={ldapSecurity} onChange={handleLdapSecurityChange} />
                                                            <div className="invalid-feedback">{errors["ldapSecurity"]}</div>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs={6} md={3} lg={3}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Search Base</Form.Label>
                                                            <Form.Control type="text" name="ldapSearchBase" className="form-control" placeholder="Enter Search Base" defaultValue={ldapSearchBase} onChange={handleLdapSearchBaseChange} />
                                                            <div className="invalid-feedback">{errors["ldapSearchBase"]}</div>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs={6} md={3} lg={3}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Domain</Form.Label>
                                                            <Form.Control type="text" name="ldapDomain" className="form-control" placeholder="Enter Domain" defaultValue={ldapDomain} onChange={handleLdapDomainChange} />
                                                            <div className="invalid-feedback">{errors["ldapDomain"]}</div>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                )}
                                            </Col>
                                            <Col xs={12} md={12} lg={12} className="text-right mt-2">
                                                <Button type="button" className="btn btn-sm btn-primary dt float-left shadow-sm" onClick={()=>handleNextTabClick ("fourth")}>Previous</Button>
                                                <Button type="button" className="btn btn-sm btn-primary dt shadow-sm" onClick={()=>{moduleNextTabfifth();}}>Next</Button>
                                            </Col>
                                        </Row>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="sixth">
                                        <Row>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Tenant POC</Form.Label>
                                                    <Form.Control id="password" type="text" name="tenantPOC" defaultValue={tenantPOC} className="form-control" placeholder="Enter Tenant POC" onChange={handleChange} />
                                                    <div className="invalid-feedback">{errors["tenantPOC"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Tenant Email ID</Form.Label>
                                                    <Form.Control id="name" type="text" name="tenantEmailID" defaultValue={tenantEmailID} className="form-control" placeholder="Enter Tenant Email ID" onChange={handleChange} onKeyUp={validateTenantEmailId} readOnly/>
                                                    <div className="invalid-feedback">{errors["tenantEmailID"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Admin First Name</Form.Label>
                                                    <Form.Control id="name" type="text" name="tenantAdminFirstName" defaultValue={tenantAdminFirstName} className="form-control" placeholder="Enter Admin First Name" onChange={handleChange}/>
                                                    <div className="invalid-feedback">{errors["tenantAdminFirstName"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Admin Middle Name</Form.Label>
                                                    <Form.Control id="name" type="text" name="tenantAdminMiddleName" defaultValue={tenantAdminMiddleName} className="form-control" placeholder="Enter Admin Middle Name" onChange={handleChange}/>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Admin Last Name</Form.Label>
                                                    <Form.Control id="name" type="text" name="tenantAdminLastName" defaultValue={tenantAdminLastName} className="form-control" placeholder="Enter Admin Last Name" onChange={handleChange}/>
                                                    <div className="invalid-feedback">{errors["tenantAdminLastName"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Admin Emp Code</Form.Label>
                                                    <Form.Control id="name" type="text" name="tenantAdminEmpCode" defaultValue={tenantAdminEmpCode} className="form-control" placeholder="Enter Admin Emp Code" onChange={handleChange}/>
                                                    <div className="invalid-feedback">{errors["tenantAdminEmpCode"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={6} md={3} lg={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Admin Contact No.</Form.Label>
                                                    <Form.Control id="name" type="number" name="adminContactNo" defaultValue={adminContactNo} className="form-control" placeholder="Enter Admin Contact No." onChange={handleChange}/>
                                                    <div className="invalid-feedback">{errors["adminContactNo"]}</div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} md={12} lg={12} className="text-right mt-2">
                                                <Button type="button" className="btn btn-sm btn-primary dt float-left shadow-sm" onClick={()=>handleNextTabClick ("fifth")}>Previous</Button>
                                                <Button type="button" className="btn btn-sm btn-primary dt shadow-sm" onClick={()=>{moduleNextTabsixth();}}>Next</Button>
                                              </Col>
                                         </Row>
                                     </Tab.Pane>
                                            
                                        <Tab.Pane eventKey="seventh">
                                            <Row style={{ margin: "0px", padding: "10px" }}>
                                             <Col xs={12} style={{ marginBottom: "10px", textAlign: "center" }}>
                                                <h2 style={{ fontSize: "1.25rem", fontWeight: "600", marginBottom: "16px" }}>
                                                       API Assignment & Cost
                                                </h2>
                                             </Col>
                                            
                                         {/* Modules List */}
                                        {mod
                                        .filter((module) => module.moduleId === "27" || module.moduleId === "23" || module.moduleId === "22" || module.moduleId === "18")
                                         .map((module) => (
                                           <Col key={module.moduleId} xs={12} style={{ marginBottom: "16px" }}>
                                            <div className="card shadow-sm" style={{ padding: "0px" }}>
                                                <div className="card-body">
                                                     {/* Module Checkbox */}
                                                       <h5 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                         <input
                                                         type="checkbox"
                                                            checked={selectedModules[module.moduleId] || false}
                                                                 onChange={(e) =>
                                                                    toggleModule(module.moduleId, e.target.checked)
                                                                    }
                                                                    className="form-check-input"
                                                                     />
                                                                        <span>{module.moduleName}</span>
                                                        </h5>
                                            
                                                        {/* Show APIs only if module is checked */}
                                                        {selectedModules[module.moduleId] && (
                                                         <ul style={{ marginLeft: "16px", marginTop: "12px", padding: "0px" }}>
                                                             {apiList
                                                                .filter((api) => api.moduleId === module.moduleId)
                                                                .map((api) => (
                                                                <li
                                                                 key={api.apiId}
                                                                     style={{
                                                                        padding: "12px",
                                                                          borderBottom: "1px solid #ddd",
                                                                          display: "flex",
                                                                           flexDirection: "column",
                                                                           gap: "8px",
                                                                        }}
                                                                    >
                                                                {/* API Name and Checkbox */}
                                                                <div
                                                                     style={{
                                                                         display: "flex",
                                                                         justifyContent: "space-between",
                                                                         alignItems: "center",
                                                                        }}
                                                                      >
                                                                <span>{api.apiName}</span>
                                                                    <div style={{ display: "flex", alignItems: "center" }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={assignedApis[api.apiId] !== undefined}
                                                                            onChange={(e) =>
                                                                            toggleAssignment(api.apiId, e.target.checked)
                                                                        }
                                                                    className="form-check-input"
                                                                    />
                                                                <span style={{ marginLeft: "8px" }}>Assign</span>
                                                             </div>
                                                            </div>
                                            
                                                            {/* Cost Input (Only enabled if "Yes" is selected) */}
                                                            <div style={{ marginTop: "8px", display: "flex" }}>
                                                                <label style={{ color: "#6c757d" }}>Cost per hit:</label>
                                                                    <input
                                                                         type="number"
                                                                        
                                                                         className="form-control form-control-sm"
                                                                         style={{ width: "80px" , marginTop:"-5px", marginLeft:"10px" }}
                                                                         value={assignedApis[api.apiId]?.cost ?? ""}
                                                                         onChange={(e) =>
                                                                          updateCost(api.apiId,  e.target.value)
                                                                         }
                                                                         onBlur={(e) => {
                                                                            const formattedValue = parseFloat(e.target.value).toFixed(2);
                                                                            updateCost(api.apiId, e.target.value);
                                                                          }}
                                                                    disabled={assignedApis[api.apiId] === undefined}
                                                                    
                                                                     />
                                                                     </div>
                                                                        </li>
                                                                            ))}
                                                                            </ul>
                                                                         )}
                                                                </div>
                                                            </div>
                                                           </Col>
                                                        ))}
                                            
                                                                {/* Wallet Balance Input */}
                                                                {mod.some((module) => ["27", "23", "22", "18"].includes(module.moduleId)) && (
                                                                <Col xs={12} style={{ marginTop: "16px" }}>
                                                                    <div style={{ marginBottom: "12px" }}>
                                                                        <label className="form-label">Wallet Balance:</label>
                                                                        <input
                                                                            type="number"
                                                                                
                                                                            className="form-control"
                                                                            style={{ width: "20%" }}
                                                                            value={walletBalance}
                                                                            onChange={(e) => setWalletBalance(e.target.value)}
                                                                            // onBlur={() => setWalletBalance((prev) => (prev ? parseFloat(prev).toFixed(2) : "0.00"))}
                                                                            
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                 )}
                                            
                                                    {/* Action Buttons */}
                                                    <Col xs={12} md={12} lg={12} className="text-right mt-2">
                                                    <Button type="button" className="btn btn-sm btn-primary dt float-left shadow-sm" onClick={()=>handleNextTabClick ("sixth")}>Previous</Button>
                                                     <Button type="button" className="btn btn-sm btn-danger dt ml-2 shadow-sm" onClick={() => closePopup()}>Cancel</Button>
                                                     <Button type="button" className="btn btn-sm btn-primary dt ml-2 shadow-sm" id="saveTenant" onClick={saveTabDetails}>Save & Submit</Button>
                                                    </Col>
                                                    </Row>
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>
                </Container>
                <Loader showLoader={showLoader} />
            </Modal.Body>
        </Modal>
    )
}
export default EditTenant;